export interface RankCardBackground {
  type: 'solid' | 'gradient';
  color: string;
  colorEnd?: string;
}

export const RANK_PRESETS = {
  gold: { type: 'gradient', color: '#E6B800', colorEnd: '#FAD05B' } as RankCardBackground,
  silver: { type: 'gradient', color: '#9D9D9D', colorEnd: '#FFFFFF' } as RankCardBackground,
  bronze: { type: 'gradient', color: '#947636', colorEnd: '#CCAA72' } as RankCardBackground,
  regular: { type: 'solid', color: '#E6F4FF' } as RankCardBackground
};

export function getRankPreset(rank: number): RankCardBackground {
  if (rank === 1) return RANK_PRESETS.gold;
  if (rank === 2) return RANK_PRESETS.silver;
  if (rank === 3) return RANK_PRESETS.bronze;
  return RANK_PRESETS.regular;
}
